module.exports = __webpack_public_path__ + "5c495f8a09a8142e895fd74fb97cd9ec.png";